import React from 'react';
import { PreImplantAligment } from '../type';
import { useLang } from '../../../../util/lang';
import TeethDisplaySummary from '../TeethDisplaySummary/TeethDisplaySummary';

/**
 * RestorativeOptionsSummary component displays a summary of restorative treatment options
 * Shows the selected restorative options including sub-options and vertical dimension settings
 * @param {Object} props - Component props
 * @param {string | JSX.Element} [props.label=''] - Display label for the summary section
 * @param {RestorativeOptions} props.restorativeOptions - The restorative options configuration object
 * @param {Object} props.teeth - Teeth object for UI display
 * @param {PreImplantAligment} props.preImplantAligment - Pre-implant alignment object for UI display
 * @returns {JSX.Element} Summary display of restorative options
 */
const PreImplantAligmentSummary = ({ teeth, label = '', preImplantAligment }) => {
    const getLang = useLang();
    // console.log("preImplantAligment in PreImplantAligmentSummary => ", preImplantAligment)
    return (
        <>
            {label}
            <p>{preImplantAligment?.value === 'Yes' ? getLang('@global.const.yes') : getLang('@global.const.no')}</p>
            {preImplantAligment?.value === 'Yes' && preImplantAligment.prostheticSpace?.length > 0 && (
                <TeethDisplaySummary teeth={teeth} toothSelection={preImplantAligment.prostheticSpace} />
            )}
        </>
    );
};

export default PreImplantAligmentSummary;
